import { render, staticRenderFns } from "./EditcommissionWithdraw.vue?vue&type=template&id=4e7964fe"
import script from "./EditcommissionWithdraw.vue?vue&type=script&lang=js"
export * from "./EditcommissionWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports